import gql from 'graphql-tag';

/** Fields of each attachment the tab Dokumente and the measurement blocks show (`AttachmentList`, `AttachmentGallery`). */
export const ATTACHMENT_FIELDS = `
  id
  path
  thumbnail
  filename
  displayFilename
  size
  mimetype
  attachmentType
  createdAt
`;

/** Legacy attachment lists and ZIP lists of the project shown in the tab Dokumente. */
const ATTACHMENT_LIST_FIELDS = [
  'acInstallationLocationAttachments',
  'acceptanceProtocolCustomerSignatureAttachments',
  'acceptanceReportImageAttachmentsZip',
  'accessCardsOfWallboxAttachments',
  'allPanelsVisibleAttachments',
  'ballastAttachments',
  'batLabelSnAttachments',
  'breakthroughsWithSealingsMeterCabinetAttachments',
  'brickAndSubstructureAttachments',
  'brickAndSubstructureOptionalAttachments',
  'brickCoverWidthAttachments',
  'bricksBackAttachments',
  'bricksFrontAttachments',
  'bricksOptionalAttachments',
  'bricksPlasteredAttachments',
  'cableAlongFacadeAttachments',
  'cableBetweenMateboxAndElectricMeterAttachments',
  'cableManagementAttachments',
  'cableManagementOptionalAttachments',
  'cablingBetweenWallboxAndDistributionAttachments',
  'cardboardPoppetAttachments',
  'circuitBreakerAndSafetySwitchForWallboxAttachments',
  'clampAreaAttachments',
  'closedHAKWithSealAttachments',
  'closedMeterCabinetInscribedComponentsAttachments',
  'closedPreMeterAreaWithPlombsAttachments',
  'combinedNetRegistrationAttachmentsZip',
  'correctBrickHandlingAttachments',
  'correctCableInputAttachments',
  'damageAttachments',
  'dongleSerialNumberAttachments',
  'earthingOptionalAttachments',
  'earthingPresentAttachments',
  'earthingSubstructureAttachments',
  'electricMeterAndGakOptionalAttachments',
  'electricMeterAttachments',
  'electricMeterOptionalAttachments',
  'electricMeterReadingAttachments',
  'equipotentialBusBarAttachments',
  'equipotentialBusBarPresentAttachments',
  'flatRoofOptionalAttachments',
  'flatRoofSurfaceAttachments',
  'gakAttachments',
  'hakAndZsSameRoomAttachments',
  'hakAttachments',
  'hakOptionalAttachments',
  'heavyCurrentPresentAttachments',
  'installationImageAttachments',
  'installationImageAttachmentsZip',
  'internetConnectionAttachments',
  'invLabelSnAttachments',
  'inverterAttachments',
  'inverterOptionalAttachments',
  'inverterSerialNumberAttachments',
  'invoiceAttachments',
  'invoiceAttachmentsZip',
  'jobSafetyOptionalAttachments',
  'layoutPlanAttachments',
  'layoutPlanAttachmentsZip',
  'locationAndCablePathOptionalAttachments',
  'mainElectricMeterAttachments',
  'mandateAttachments',
  'mandateAttachmentsZip',
  'mateboxSerialNumberAttachments',
  'measurementAttachments',
  'measurementProtocolInclPhotosAttachments',
  'measurementReportAttachments',
  'measurementReportImageAttachmentsZip',
  'measurementResultAttachments',
  'measurementsOptionalAttachments',
  'miscAttachments',
  'miscAttachmentsZip',
  'monitoringOptionalAttachments',
  'mtbxLabelSnAttachments',
  'netConnectionTerms',
  'netRegistrationAttachments',
  'netRegistrationAttachmentsGenerated',
  'netRegistrationAttachmentsGeneratedZip',
  'netRegistrationAttachmentsZip',
  'offerAttachments',
  'offerAttachmentsZip',
  'openHAKAttachments',
  'openMateboxAttachments',
  'openMeterCabinetPrePostAreaAttachments',
  'operationRegistrationAttachments',
  'operationRegistrationAttachmentsGenerated',
  'operationRegistrationAttachmentsGeneratedZip',
  'operationRegistrationAttachmentsZip',
  'outerRoofOptionalAttachments',
  'overviewSchematicAttachments',
  'overviewSchematicAttachmentsGenerated',
  'overviewSchematicAttachmentsGeneratedZip',
  'overviewSchematicAttachmentsZip',
  'panelBottomViewAttachments',
  'pedimentAttachments',
  'photoOfWallboxAttachments',
  'pitchedRoofOptionalAttachments',
  'potentialGroundRodAttachments',
  'potentialOptionalAttachments',
  'projectDescriptionAttachments',
  'projectDescriptionAttachmentsZip',
  'protectedUnderBrickCableRoutingAttachments',
  'rafterOptionalAttachments',
  'rafterVisibleAttachments',
  'railOverlapAttachments',
  'railToRoofDistanceAttachments',
  'reportAttachments',
  'roofAccessAttachments',
  'roofAccessOptionalAttachments',
  'roofHookWithEarthingAttachments',
  'roofSidesAttachments',
  'roofSidesOptionalAttachments',
  'roofSidesShadowsAttachments',
  'roofSidesSketchAttachments',
  'scaffoldAttachments',
  'screenshotDeviceFlow',
  'screenshotModeOfOperation',
  'seconaryElectricMeterAttachments',
  'serrviceHakLockedAttachments',
  'serviceAdditionalSubDistributionAttachments',
  'serviceAllPanelsVisibleAttachments',
  'serviceBrickAndSubstructureAttachments',
  'serviceBrickAndSubstructureOptionalAttachments',
  'serviceBrickCoverWidthAttachments',
  'serviceCableAlongFacadeAttachments',
  'serviceCableAndPlugAttachedToRailStateAttachments',
  'serviceCableManagementAttachments',
  'serviceCableManagementOptionalAttachments',
  'serviceCablePath360Attachments',
  'serviceClampAreaAttachments',
  'serviceCorrectBrickHandlingAttachments',
  'serviceCorrectCableInputAttachments',
  'serviceDisassembledMetersAttachments',
  'serviceEarthingAttachments',
  'serviceFiLsWallboxAttachments',
  'serviceHakAndZsSameRoomAttachments',
  'serviceHakAttachments',
  'serviceInstallationLocationWithInverterAndMateboxAttachments',
  'serviceMainElectricMeterAttachments',
  'serviceMiscOptionalAttachments',
  'serviceOpenMatebox',
  'servicePanelBottomViewAttachments',
  'serviceProtectedUnderBrickCableRoutingAttachments',
  'serviceRailOverlapAttachments',
  'serviceRailOverlappingTerminationFittingAttachments',
  'serviceReportImageAttachmentsZip',
  'serviceSeconaryElectricMeterAttachments',
  'serviceSecondaryInstallationLocationAttachments',
  'serviceSolarPanelsOptionalAttachments',
  'serviceStringPlanAttachments',
  'serviceTrayfDistanceAttachments',
  'serviceWallboxAccessCardAttachments',
  'serviceWallboxAttachments',
  'serviceWallboxCablePathNotes',
  'serviceWallboxLocationAttachments',
  'serviceZsDistributionAreaAttachments',
  'serviceZsPostCounterAreaAttachments',
  'serviceZsPreCounterAreaAttachments',
  'serviceZsSerialNumberAttachments',
  'serviceZsWithCoverAttachments',
  'serviceZsWithoutCoverAttachments',
  'solarModuleTypePlateAttachments',
  'solarPanelsOptionalAttachments',
  'storageSerialNumberAttachments',
  'stringPlanAttachments',
  'trayfDistanceAttachments',
  'variousBreakthroughsWithPossibleSealingsAttachments',
  'wallboxLocationAttachments',
  'wallboxOptionalAttachments',
  'warrantyQCellsAttachments',
  'zsOptionalAttachments',
  'zsWithCoverAttachments',
  'zsWithoutCoverAttachments',
];

/** Build states of the generated PDFs and of the ZIPs (`ButtonWait`, `ZipDownload`). */
const BUILD_STATE_FIELDS = [
  'acceptanceReportImageAttachmentsZipBuildState',
  'combinedNetRegistrationAttachmentsZipBuildState',
  'installationImageAttachmentsZipBuildState',
  'invoiceAttachmentsZipBuildState',
  'layoutPlanAttachmentsZipBuildState',
  'mandateAttachmentsZipBuildState',
  'measurementReportAttachmentsBuildState',
  'measurementReportImageAttachmentsZipBuildState',
  'miscAttachmentsZipBuildState',
  'netRegistrationAttachmentsBuildState',
  'netRegistrationAttachmentsGeneratedZipBuildState',
  'netRegistrationAttachmentsZipBuildState',
  'offerAttachmentsZipBuildState',
  'operationRegistrationAttachmentsBuildState',
  'operationRegistrationAttachmentsGeneratedZipBuildState',
  'operationRegistrationAttachmentsZipBuildState',
  'overviewSchematicAttachmentsBuildState',
  'overviewSchematicAttachmentsGeneratedZipBuildState',
  'overviewSchematicAttachmentsZipBuildState',
  'projectDescriptionAttachmentsZipBuildState',
  'reportAttachmentsBuildState',
  'serviceReportImageAttachmentsZipBuildState',
];

const attachmentListSelections = ATTACHMENT_LIST_FIELDS.map(
  (field) => `${field} {${ATTACHMENT_FIELDS}}`
).join('\n');

/**
 * Data of the block project-documents: everything the tab Dokumente shows, one block for the whole
 * tab (see feature page projekt-dokumente). `attachments` holds only the service contracts; client,
 * power company and requirements are reference data for the organization rule and the hints on
 * missing data. Read through `Project.blocks.documents`, which checks the block's read permission.
 */
export const PROJECT_DOCUMENTS_FIELDS = gql`
  fragment projectDocumentsFields on ProjectDocumentsBlock {
    id
    number
    attachments {${ATTACHMENT_FIELDS}}
    client {
      id
      name
    }
    powerCompany {
      _id
      company
      netRegistrationDocumentsApprovedState
      operationRegistrationDocumentsApprovedState
    }
    netRegistrationRequirements {
      name
      fullfilledState
    }
    ${attachmentListSelections}
    ${BUILD_STATE_FIELDS.join('\n')}
  }
`;
